<template>
  <v-card>
    <v-toolbar color="white" elevation="4" flat prominent>
      <v-row>
        <v-col cols="12" sm="12" md="6" lg="6">
          <v-text-field
            class="mr-3"
            v-model="search"
            flat
            hide-details
            label="Filter News"
            solo-inverted
          ></v-text-field>
        </v-col>
        <v-row class="mt-4" cols="12" sm="12" md="6" lg="6">
          <v-btn class="mr-5" large outlined @click="this.openDialog">
            <v-icon class="mr-2"> mdi-note-plus-outline</v-icon>
            Add News</v-btn
          >

          <v-select
            v-model="selected_lang"
            style="max-width: 100px"
            :items="lang_items"
            label="Language"
            outlined
            class="mt-2"
          ></v-select>
        </v-row>
        <v-col cols="12" sm="12" md="6" lg="6">
          <v-card
            v-if="tabs == 0"
            v-show="search"
            height="65px"
            class="filter-card-offset scroll-vertical"
          >
            <v-chip
              v-for="(keyword, i) in keywords"
              small
              @click="setFilter(keyword)"
              :key="i"
              class="black--text mr-2"
            >
              {{ keyword }}
            </v-chip>
          </v-card>
          <!-- Keyword for Fake -->
          <v-card
            v-if="tabs == 1"
            v-show="search"
            height="65px"
            class="filter-card-offset scroll-vertical"
          >
            <v-chip
              v-for="(keyword, i) in keywordsFake"
              small
              @click="setFilter(keyword)"
              :key="i"
              class="black--text mr-2"
            >
              {{ keyword }}
            </v-chip>
          </v-card>
        </v-col>
      </v-row>
      <dialog-container>
        <div slot="content">
          <add-news-form :lang="this.selected_lang" />
        </div>
      </dialog-container>
      <template v-slot:extension>
        <v-tabs v-model="tabs" centered>
          <v-tab dark>
            <label class="primary_whiten--text"> News </label></v-tab
          >
          <v-tab class="orange--text">Fake Alert</v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <v-divider> </v-divider>

    <v-tabs-items v-model="tabs">
      <!-- News  -->

      <v-tab-item>
        <v-row>
          <v-col
            cols="6"
            sm="6"
            md="6"
            v-for="(item, index) in searching"
            :key="index"
          >
            <news-list
              :id="item.id"
              :title="item.title"
              :date="item.date"
              :time="item.time"
              :source="item.source"
              :body="item.body"
              :image="item.image"
              :lang="selected_lang"
            />
          </v-col>
        </v-row>
      </v-tab-item>
      <!-- Fake News  -->
      <v-tab-item>
        <v-row>
          <v-col
            cols="6"
            sm="6"
            md="6"
            v-for="(item, index) in searchingFake"
            :key="index"
          >
            <news-list
              :id="item.id"
              :title="item.title"
              :date="item.date"
              :time="item.time"
              :body="item.body"
              :source="item.source"
              :mark="item.mark"
              :image="item.image"
              :lang="selected_lang"
            />
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template> 

<script>
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
import { eventBus } from "@/main.js";
import moment from "moment";
import NewsList from "../components/NewsList";
import DialogContainer from "../shared/components/dialogContainer";
import AddNewsForm from "../forms/AddNewsForm";
export default {
  name: "News",
  async created() {
    await this.fetchAllNews(this.selected_lang);
  },
  components: {
    NewsList,
    AddNewsForm,
    DialogContainer,
  },
  computed: {
    ...mapFields("news", ["allNews", "fakeNews"]),
    keywords() {
      if (!this.search) return [];

      const keywords = [];

      for (const search of this.searching) {
        keywords.push(search.title);
      }

      return keywords;
    },
    keywordsFake() {
      if (!this.search) return [];

      const keywords = [];

      for (const search of this.searchingFake) {
        keywords.push(search.title);
      }

      return keywords;
    },

    searching() {
      if (!this.search) return this.news;

      const search = this.search.toLowerCase();

      return this.news.filter((item) => {
        const text = item.title.toLowerCase();
        return text.indexOf(search) > -1;
      });
    },
    searchingFake() {
      if (!this.search) return this.fakeNewsList;

      const search = this.search.toLowerCase();

      return this.fakeNewsList.filter((item) => {
        const text = item.title.toLowerCase();
        return text.indexOf(search) > -1;
      });
    },
  },

  data() {
    return {
      tab: null,
      tabs: null,
      news: [],
      fakeNewsList: [],
      fake: "FAKE",
      fecthedFakeNews: false,
      search: "",
      lang_items: ["en", "ar", "am"],
      selected_lang: "en",
    };
  },
  methods: {
    ...mapActions("news", ["currentNewsTab", "fetchAllNews", "fetchFakeNews"]),
    ...mapActions("shared", ["showEditForm"]),

    openDialog() {
      // set the form as New form
      this.showEditForm({
        payload: {
          isEdit: false,
        },
      });
      eventBus.$emit("formChangeEvent", true);
      eventBus.$emit("dialogToggle", true);
    },
    setFilter(search) {
      this.search = search;
    },
    async fetchAllFakeNews() {
      await this.fetchFakeNews(this.selected_lang);
    },
  },
  watch: {
    selected_lang: {
      immidate: true,
      handler: async function (value) {
        await this.fetchAllNews(value);
        await this.fetchFakeNews(value);
      },
    },
    tabs: {
      immidate: true,
      handler(value) {
        // Do not fetch fake news on page load for Increased Render speed
        // But fetch the Fake News when the user moves to that Tab for the first time
        if (value === 1 && !this.fecthedFakeNews) {
          this.fecthedFakeNews = true;
          this.fetchAllFakeNews();
        }

        // clear filters when moving between tabs
        this.search = "";

        // set current Tab for News/fake
        this.currentNewsTab({
          tab: this.tabs,
        });
      },
    },
    allNews: {
      immidate: true,
      handler(value) {
        if (value.length != 0) {
          this.news = [];
          value.map((news, index) => {
            this.news.push({
              id: news.id,
              image: news.content.image || "",
              title: news.content.title,
              body: news.content.body,
              source: news.content.source,
              date: news.content.date,
              time: "",
            });
          });
        }
      },
    },
    fakeNews: {
      immidate: false,
      handler(value) {
        if (value.length != 0) {
          this.fakeNewsList = [];
          value.map((fake) => {
            this.fakeNewsList.push({
              id: fake.id,
              image: fake.content.image || "",
              title: fake.content.title,
              body: fake.content.body,
              source: fake.content.source,
              date: fake.content.date,
              time: "",
              mark: this.fake,
            });
          });
        }
      },
    },
  },
};
</script>

<style scoped>
.filter-card-offset {
  margin-top: -20px;
}
</style>